import React from 'react'
import omit from 'lodash/omit'
import CircularProgress from 'material-ui/CircularProgress'
import FlatButton from 'material-ui/FlatButton'
import { withRouter } from 'react-router'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import api from '../../api'
import FilterModal from './filterModal'
import reports from './reports'

class Reports extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      pendingExports: {},
      filterModalOpen: false,
      selectedReport: null
    }
  }

  componentDidMount () {
    // Check if there are any pending exports
    api.get('admin/exports')
      .then(res => res.json())
      .then(exports => {
        const pendingExports = {}
        exports.forEach(exp => {
          if (exp.status === 'pending' || exp.status === 'processing') {
            // Find the report that matches this export
            const report = reports.find(r => r.path.endsWith(exp.type))
            if (report) {
              pendingExports[report.path] = true
            }
          }
        })

        if (Object.keys(pendingExports).length > 0) {
          this.setState({ pendingExports })
        }
      })
      .catch(err => {
        console.error('Failed to fetch exports:', err)
      })
  }

  handleFilterModalOpen (report) {
    this.setState(state => ({
      ...state,
      filterModalOpen: true,
      selectedReport: report
    }))
  }

  handleFilterModalClose () {
    this.setState(state => ({
      ...state,
      filterModalOpen: false,
      selectedReport: null
    }))
  }

  handleExport (report) {
    const { filters } = report

    if (filters) {
      this.handleFilterModalOpen(report)
    } else {
      this.handleExportStart(report)
    }
  }

  handleExportStart (report, appliedFilters = {}) {
    const { filters, path } = report

    this.setState(state => {
      const pendingExports = { ...state.pendingExports, [path]: true }
      return {
        ...state,
        pendingExports,
        filterModalOpen: false,
        selectedReport: null
      }
    })

    const options = filters
      ? { body: { filters: appliedFilters } }
      : {}

    api.get(report.path, options)
      .then(res => this.handleExportReady(report, res))
      .catch(err => {
        this.setState(state => ({
          ...state,
          pendingExports: omit(state.pendingExports, path)
        }))

        throw err
      })
  }

  handleExportReady (report, response) {
    const { path } = report
    response.json().then(body => {
      this.setState(state => ({
        ...state,
        pendingExports: omit(state.pendingExports, path)
      }))

      // Redirect to the exports page if the export was queued successfully
      if (body && body.id) {
        this.props.router.push('/reports/exports')
      }
    })
  }

  renderReportAction (report) {
    const { pendingExports } = this.state

    if (pendingExports[report.path]) {
      return (
        <FlatButton
          disabled
          label='Processing...'
          icon={<CircularProgress size={20} />}
        />
      )
    } else {
      return (
        <FlatButton
          primary
          label='Export'
          onClick={() => this.handleExport(report)}
          disabled={this.state.isExporting}
        />
      )
    }
  }

  render () {
    return (
      <div>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn>Report</TableHeaderColumn>
              <TableHeaderColumn />
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {reports.map((report, i) => (
              <TableRow key={i} selectable={false}>
                <TableRowColumn>
                  {report.name}
                </TableRowColumn>
                <TableRowColumn style={{ textAlign: 'right' }}>
                  {this.renderReportAction(report)}
                </TableRowColumn>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {this.state.filterModalOpen && (
          <FilterModal
            filters={this.state.selectedReport.filters}
            onExport={this.handleExportStart.bind(this, this.state.selectedReport)}
            onClose={this.handleFilterModalClose.bind(this)}
          />
        )}
      </div>
    )
  }
}

export default withRouter(Reports)
